import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/machines/SuccessfulAddMachineDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddMachine_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddMachine_action_icon' />
        <Typography className='SuccessfulAddMachine_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfulAddMachineDialog = ({ openSuccessfulAddMachine, setOpenSuccessfulAddMachine, machineId, setOpenAddMachine }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleOpenAdd = useCallback(() => {
        setOpenSuccessfulAddMachine(false);
        setOpenAddMachine(true);
    }, [setOpenAddMachine, setOpenSuccessfulAddMachine]);

    const handleNavigateToMachinePage = useCallback(() => {
        navigate(`machine_details/${machineId}`);
    }, [machineId, navigate]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddMachine(false);
    }, [setOpenSuccessfulAddMachine]);

    return (
        <Dialog open={openSuccessfulAddMachine} onClose={handleClose} classes={{ paper: 'SuccessfulAddMachine_dialog' }}>
            <IconButton onClick={handleClose} className='SuccessfulAddMachine_icon_button'>
                <Iconify icon={"material-symbols:close"} className='SuccessfulAddMachine_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddMachine_dialog_content' >
                <Iconify icon={"lets-icons:check-ring-light"} className='SuccessfulAddMachine_check_icon' />
                <Typography className='SuccessfulAddMachine_message'>{t('AddMachine_validation_message')}</Typography>
                <Box className='SuccessfulAddMachine_action_container'>
                    <ActionBox
                        icon={"pepicons-pop:file"}
                        text={t('toPageMachine')}
                        onClick={handleNavigateToMachinePage}
                    />
                    <ActionBox
                        icon={"material-symbols-light:cards-outline"}
                        text={t('toPageMachineList')}
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon={"material-symbols-light:add"}
                        text={t('addMachineButton')}
                        onClick={handleOpenAdd}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};